<template>
  <div>
    <!-- {{ data }} 1 -->
    <v-card @click="openDialog" class="action-card" v-if="!data">
      <v-img
        width="100px"
        max-height="50px"
        :src="require('@/assets/RabbitG.png')"
      />
    </v-card>
    <!--  -->
    <v-btn color="question" fab small dark v-else @click="openDialog()">
      <v-icon> mdi-tools </v-icon>
    </v-btn>

    <!-- Dialog for SlipOK -->
    <v-dialog v-model="dialogSlipOK" persistent max-width="550px">
      <v-card>
        <!-- {{ data }} -->
        <v-form ref="form" v-model="validAdd" lazy-validation>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="8">
                  <h3><strong>ตั้งค่าข้อมูล SlipOK</strong></h3>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-btn
                    fab
                    small
                    dark
                    color="white"
                    :style="styleCloseBt"
                    @click="closeDialog"
                  >
                    X
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    name="input-7-1"
                    v-model="form.api_rabbit"
                    label="API Key (secret)"
                    outlined
                    :rules="rules.apiKey"
                  />
                </v-col>
              </v-row>

              <v-row class="align-center justify-center">
                <v-col cols="10">
                  <p class="mb-0">
                    {{ form.switchSlipOK ? "เปิดใช้งาน" : "ปิดใช้งาน" }} rabbit
                    gateway
                  </p>
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-switch v-model="form.switchRabbit"></v-switch>
                </v-col>
                <v-col>
                  <v-btn
                    block
                    dark
                    color="rgb(27, 67, 124)"
                    @click="saveData(data)"
                    >บันทึก</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SlipOK',

  data () {
    return {
      dialogSlipOK: false,
      validAdd: true,
      form: {
        api_rabbit: '',
        switchRabbit: true
      },
      rules: {
        apiKey: [
          v => /^[^\s]+$/.test(v) || 'No spaces allowed',
          v => !!v || 'API KEY is required'
        ]
      },
      styleCloseButton: 'border-radius: 50%; color: red;'
    }
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    status: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    openDialog () {
      // ถ้ากดปุ่มแก้ไข จะส่ง param มา
      if (this.data) {
        this.form.api_rabbit = this.data.api_rabbit
        // this.form.apiKey = this.data.apiKey;
        this.form.payTypeId = this.data.payTypeId
        this.form.switchRabbit = this.data.switchRabbit === 'True'
      }

      if (!this.status) {
        this.dialogSlipOK = true
      } else {
        this.$swal('ไม่สำเร็จ', 'ตรวจพบรายการก่อนหน้านี้แล้ว', 'error')
      }
    },
    closeDialog () {
      this.dialogSlipOK = false
      this.resetForm()
      this.reset()
    },
    resetForm () {
      this.form.branchId_slipOK = ''
      this.form.apiKey = ''
      this.form.switchSlipOK = true
    },
    saveData () {
      if (this.$refs.form.validate()) {
        this.submit()
        // this.onChackQuotaSlipOK(this.form.branchId_slipOK, this.form.apiKey)
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    // onChackQuotaSlipOK (branchIdSlipOK, apiKey) {
    //   const body = {
    //     branchId_slipOK: branchIdSlipOK + '/quota',
    //     apiKey: apiKey
    //   }
    //   try {
    //     axios.post(this.$DNS_IP + '/check_SlipOK', body).then(res => {
    //       if (res.data.success) {
    //         // เช็คผ่าน ให้ทำต่อ
    //         if (!this.form.payTypeId) {
    //           this.form.payTypeCode = this.code + this.generateCodeGlobal()
    //           this.form.payTypeName = 'SlipOK'
    //           this.form.CREATE_USER = this.$session.getAll().data.userName
    //           this.form.LAST_USER = this.$session.getAll().data.userName
    //           this.form.shopId = this.$session.getAll().data.shopId
    //           this.form.payType = 'SlipOK'
    //         }

    //         this.form.branchId_slipOK = this.form.branchId_slipOK.replaceAll(' ', '')
    //         this.form.apiKey = this.form.apiKey.replaceAll(' ', '')
    //         this.submit()
    //       } else {
    //         // เช็คไม่ผ่าน ให้แจ้งเตือน
    //         let errorMsg = ''
    //         if (res.data.code === 1001) {
    //           errorMsg = 'BRANCH ID ไม่ถูกต้อง'
    //         } else if (res.data.code === 1002) {
    //           errorMsg = 'API KEY ไม่ถูกต้อง'
    //         } else if (res.data.code === 1003) {
    //           errorMsg = 'Package ของคุณหมดอายุแล้ว'
    //         }
    //         this.$swal('ไม่สำเร็จ', errorMsg, 'error')
    //       }
    //     })
    //   } catch (error) {
    //     console.log('error => ', error)
    //   }
    // },
    submit () {
      try {
        this.$swal({
          title:
            !this.form.payTypeId || this.form.payTypeId === ''
              ? 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?'
              : 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',

          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        }).then(result => {
          this.form.payTypeCode = this.code + this.generateCodeGlobal()
          this.form.payTypeName = 'rabbit'
          this.form.CREATE_USER = this.$session.getAll().data.userName
          this.form.LAST_USER = this.$session.getAll().data.userName
          this.form.shopId = this.$session.getAll().data.shopId
          this.form.payType = 'rabbit'
          if (!this.form.payTypeId || this.form.payTypeId === '') {
            try {
              // add
              axios
                .post(this.$DNS_IP + '/master_payment/add', this.form)
                .then(res => {
                  this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                  this.closeDialog()
                  this.$emit('selectBranch')
                })
            } catch (error) {
              console.log('error', error)
              this.$swal('ไม่สำเร็จ', 'ลองใหม่อีกครั้ง', 'success')
            }
          } else {
            // update
            try {
              axios
                .post(
                  this.$DNS_IP + '/master_payment/edit/' + this.form.payTypeId,
                  this.form
                )
                .then(res => {
                  this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                  this.closeDialog()
                  this.$emit('selectBranch')
                })
            } catch (error) {
              console.log('error', error)
              this.$swal('ไม่สำเร็จ', 'ลองใหม่อีกครั้ง', 'success')
            }
          }
        })
      } catch (error) {
        console.log('error => ', error)
      }
    }
  }
}
</script>

<style scoped>
.action-card {
  border-radius: 5px;
  border: solid #1d00ff4a;
  margin-right: 5px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Extensions/rabbit_gateway.vue